<template>
  <div id="characters" class="characters">
    <headline>Character</headline>
    <div class="characters-container">
      <character v-for="profile in profiles" :key="profile.keyName" v-bind="profile"></character>
    </div>
  </div>
</template>

<script>
import headline from './common/headline'
import character from './character'
import { profiles } from '../../utils/profiles'

export default {
  name: 'Characters',
  components: { headline, character },
  data() {
    return {
      profiles: profiles
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../stylesheets/variables.scss';

.characters-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: space-around;
}

@media screen and (max-width: $break-point) {
  .characters-container {
    width: 100%;
    justify-content: center;
  }
}
</style>
